import { INATIVAR_GRUPO_USUARIO, OBTER_GRUPO_USUARIO, OBTER_GRUPO_USUARIO_ATRIBUTO, SALVAR_GRUPO_USUARIO } from './mutations-types'
export default {
   [OBTER_GRUPO_USUARIO](state, payload) {
      state.grupoUsuario = payload
   },

   [OBTER_GRUPO_USUARIO_ATRIBUTO](state, payload) {
      state.grupoUsuarioAtributo = payload
   },

   [SALVAR_GRUPO_USUARIO](state, payload) {
      if (payload) {
         state.grupoUsuarioSalvo = payload
      } else {
         state.grupoUsuarioSalvo = null
      }
   },

   [INATIVAR_GRUPO_USUARIO](state, payload) {
      if (payload) {
         state.grupoUsuarioInativo = payload
      } else {
         state.grupoUsuarioInativo = null
      }
   }
}
